export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileAutonomia');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileAutonomia');
    }
}
